var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqBurgundy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.383 12.191a10.152 10.152 0 01-1.727 5.658.8.8 0 11-1.324-.885 8.541 8.541 0 10-2.692 2.588.8.8 0 11.825 1.362 10.193 10.193 0 114.918-8.723zm-10.191 4.937a.8.8 0 10.8.8.8.8 0 00-.8-.8zm1.672-3.366a4.256 4.256 0 002.588-3.92v-.04a4.259 4.259 0 00-8.518.04.8.8 0 001.592 0 2.667 2.667 0 015.334 0v.032a2.666 2.666 0 01-1.622 2.426 3.107 3.107 0 00-1.838 2.837.8.8 0 101.592 0 1.5 1.5 0 01.871-1.375zm0 0",
    fill: "#97144d"
  })));
}
export default SvgFaqBurgundy;